var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 2C3.59315 2 2.25 3.34315 2.25 5V19C2.25 20.6569 3.59315 22 5.25 22H19.25C20.9069 22 22.25 20.6569 22.25 19V5C22.25 3.34315 20.9069 2 19.25 2H5.25ZM13.25 6C13.8023 6 14.25 6.44772 14.25 7C14.25 8.10457 15.1454 9 16.25 9C16.8023 9 17.25 9.44771 17.25 10C17.25 10.5523 16.8023 11 16.25 11C15.5214 11 14.8383 10.8052 14.25 10.4649V14.5V14.5032C14.2482 16.4347 12.6819 18 10.75 18C8.817 18 7.25 16.433 7.25 14.5C7.25 12.9227 8.4231 11.3506 10.0511 11.0202C10.5923 10.9103 11.1201 11.26 11.23 11.8013C11.3399 12.3425 10.9902 12.8703 10.4489 12.9802C9.81207 13.1095 9.25 13.8125 9.25 14.5C9.25 15.3284 9.92157 16 10.75 16C11.5784 16 12.25 15.3284 12.25 14.5V7C12.25 6.44772 12.6977 6 13.25 6Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokFilled);
export default __webpack_public_path__ + "static/media/tiktok-filled.c1db62ff29284be7926c3dfaa40a635c.svg";
export { ForwardRef as ReactComponent };